import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';
import type { AxiosResponse } from 'axios';

export const getShipmentRoutingTypesListAPI = () => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/GetShipmentRoutingType`,
    method: 'get',
  });
};

export type ShipmentRoutingTypesResponse = {
  codeId: string; // S, T
  codeDesc: string; // SpotBid, Tender
  value1: null;
  value2: null;
  value3: null;
  string1: null;
  string2: null;
  string3: null;
}[];

export const fetchShipmentRoutingTypes = async (): Promise<ShipmentRoutingTypesResponse> => {
  const response: AxiosResponse<ShipmentRoutingTypesResponse> = await getShipmentRoutingTypesListAPI();
  return response.data;
};
